import { IBrandCountsByGeo } from "./IBrandCountsByGeo";

export interface IBrand {
  brandId: string;
  brandName: string;
  naicsCode: string;
  logoPath: string;
  minSqft: number;
  maxSqft: number;
  countsByBUDS: IBrandCountsByGeo[];
  countsByCountry: IBrandCountsByGeo[];
  countsByCounty: IBrandCountsByGeo[];
  countsByDMA: IBrandCountsByGeo[];
  countsByRegion: IBrandCountsByGeo[];
  countsByState: IBrandCountsByGeo[];
  /** This is used as a sum of the count array depending on the selected geography choice.
   * Meaning - if they chose States (when creating the report, then it will be a sum of the values
   * in the countsByState array).
   */
  totalCountByGeography: number;
  isShoppingCenter: boolean;
}
